import React from 'react';
import { motion } from 'framer-motion';
import { BookIcon, FlameIcon } from '../icons/SalesIcons';
import { SectionDivider } from '../ui/SectionDivider';
export function CurriculumSection() {
  const modules = [{
    num: 1,
    title: 'Bienvenida',
    desc: 'Orientación completa + acceso a comunidad privada Telegram y WhatsApp'
  }, {
    num: 2,
    title: 'Herramientas e Insumos',
    desc: 'Todo lo que necesitas antes de comenzar (sin malgastar dinero)'
  }, {
    num: 3,
    title: 'Tipos de Cera',
    desc: 'Soja APF/BPF, Soja-Coco, Palma, Parafina, Gel — diferencias reales y cuándo usar cada una'
  }, {
    num: 4,
    title: 'Esencias y Aceites',
    desc: 'Fragancias vs aceites esenciales: cómo elegir y medir correctamente'
  }, {
    num: 5,
    title: 'Aditivos, Colorantes y Pabilos',
    desc: 'La guía definitiva del pabilo + tabla de referencia para nunca equivocarte'
  }, {
    num: 6,
    title: 'Fórmula Exacta de Medidas',
    desc: 'Los porcentajes precisos para velas en recipiente y en molde'
  }, {
    num: 7,
    title: 'Vela Aromática con Cera de Palma',
    desc: 'Paso a paso completo'
  }, {
    num: 8,
    title: 'Vela Aromática con Cera de Soya BPF',
    desc: 'Paso a paso completo'
  }, {
    num: 9,
    title: 'Vela de Molde',
    desc: 'Moldes de silicona, desmolde y resultado profesional'
  }, {
    num: 10,
    title: 'Vela de Masaje Soja-Coco',
    desc: 'Con manteca de karité + aceite esencial + aceite de almendras'
  }, {
    num: 11,
    title: 'Vela Marmolizada Decorativa',
    desc: 'Técnica de marmoleado paso a paso'
  }, {
    num: 12,
    title: 'Tablet Wax',
    desc: 'Materiales y elaboración detallada'
  }, {
    num: 13,
    title: 'Wax Melt para Pebeteros',
    desc: 'Wax melts básicos y decorativos con resultado final'
  }, {
    num: 14,
    title: 'Velas de Jardín con Flores Preservadas',
    desc: 'Manejo de moldes acrílicos y flores secas'
  }, {
    num: 15,
    title: 'Vela en Parafina Gel',
    desc: 'Con todas las medidas de seguridad incluidas'
  }, {
    num: 16,
    title: 'Vela Repostería: Torta Glaseada',
    desc: 'Manejo de crema batida detallado'
  }, {
    num: 17,
    title: 'Vela Repostera con Chantilly',
    desc: 'Cremas y boquillas paso a paso'
  }, {
    num: 18,
    title: 'Vela Cupcake Horneado',
    desc: 'Técnica de horneado completa'
  }, {
    num: 19,
    title: 'Vela de Bola de Helado',
    desc: 'Cremas y boquillas para acabado hiperrealista'
  }, {
    num: 20,
    title: 'Material Adicional (BONOS)',
    desc: 'Ver detalle en la sección de bonos'
  }, {
    num: 21,
    title: 'Video Respuestas FAQ',
    desc: 'Los 7 errores más comunes resueltos en video'
  }];
  const moduleGroups = [{
    name: 'Fundamentos',
    range: [1, 6],
    color: 'from-[#C4A882] to-[#9B2335]'
  }, {
    name: 'Técnicas Core',
    range: [7, 11],
    color: 'from-[#9B2335] to-[#C4A882]'
  }, {
    name: 'Especialidades',
    range: [12, 15],
    color: 'from-[#C4A882] to-[#D4A0A0]'
  }, {
    name: 'Repostería',
    range: [16, 19],
    color: 'from-[#D4A0A0] to-[#9B2335]'
  }, {
    name: 'Extras',
    range: [20, 21],
    color: 'from-[#9B2335] to-[#C4A882]'
  }];
  return <section className="bg-[#FFFAF5] py-16 md:py-24" data-id="element-91">
      <div className="max-w-7xl mx-auto px-4" data-id="element-92">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-93">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-94">
            <FlameIcon size={40} className="text-[#9B2335]" data-id="element-95" />
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-[#5C4033] mb-4" data-id="element-96">
            Todo Lo Que Incluye Tu Curso
          </h2>
          <p className="text-xl text-[#2D2926]" data-id="element-97">
            21 módulos completos de cero a profesional
          </p>
        </motion.div>

        {/* Course Mockup Image */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="mb-12" data-id="element-98">
          <img src="https://cdn.magicpatterns.com/uploads/a69GoAGqLzmjriMzynPvaf/mk-3.png" alt="Vista general del curso Ilumina y Crea - Todo incluido" className="w-full max-w-4xl mx-auto rounded-2xl shadow-2xl" data-id="element-99" />
        </motion.div>

        <SectionDivider variant="ornament" data-id="element-100" />

        {/* Module Groups Legend */}
        <div className="flex flex-wrap justify-center gap-4 mb-8" data-id="element-101">
          {moduleGroups.map(group => <div key={group.name} className="flex items-center gap-2" data-id="element-102">
              <div className={`w-4 h-4 rounded-full bg-gradient-to-r ${group.color}`} data-id="element-103" />
              <span className="text-sm text-[#5C4033] font-medium" data-id="element-104">
                {group.name}
              </span>
            </div>)}
        </div>

        {/* Modules Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-105">
          {modules.map((module, index) => {
          const group = moduleGroups.find(g => module.num >= g.range[0] && module.num <= g.range[1]);
          return <motion.div key={module.num} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.03
          }} className="bg-white rounded-xl p-5 shadow-md border border-[#C4A882]/20 hover:border-[#C4A882] hover:shadow-lg transition-all duration-300" data-id="element-106">
                <div className="flex items-start gap-4" data-id="element-107">
                  <div className={`w-12 h-12 rounded-full bg-gradient-to-br ${group?.color || 'from-[#C4A882] to-[#9B2335]'} flex items-center justify-center flex-shrink-0`} data-id="element-108">
                    <span className="text-white font-bold" data-id="element-109">{module.num}</span>
                  </div>
                  <div className="flex-1" data-id="element-110">
                    <h3 className="font-heading text-lg text-[#5C4033] mb-1" data-id="element-111">
                      {module.title}
                    </h3>
                    <p className="text-sm text-[#2D2926]" data-id="element-112">{module.desc}</p>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}